import { render } from "./UserAssignmentsList.vue?vue&type=template&id=341b4704&scoped=true"
import script from "./UserAssignmentsList.vue?vue&type=script&lang=js"
export * from "./UserAssignmentsList.vue?vue&type=script&lang=js"

import "./UserAssignmentsList.vue?vue&type=style&index=0&id=341b4704&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341b4704"]])

export default __exports__